/* eslint-disable */
// import './jquery-3.4.1.min.js'

/*
if (!window.Promise) {
  window.Promise = Promise;
}
if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('/sw.js', {
        scope: ''
    })
    .then(function (registration) {
      console.log('Service worker registered with scope: ', registration.scope);
    })
    .catch(function(err) {
      console.log('ServiceWorker registration failed: ', err);
    });
}
*/

// import event bus to conduct query requests state
import { eventBus } from './App.vue'

// Import JQuery
var script = document.createElement('script');
script.src = 'http://code.jquery.com/jquery-3.4.1.min.js';
script.type = 'text/javascript';
document.getElementsByTagName('head')[0].appendChild(script);

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////// BASIC QUERIES /////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// Query to retrieve data to fulfill a map with companies' specific locations
var mapQuery = {
  measures: [
    'Facts.count'
  ],
  dimensions: [
    'Company.id',
    'Company.name',
    'Coordinates.latitude',
    'Coordinates.longitude'
  ],
  filters: [
    {
      member: 'Coordinates.latitude',
      operator: 'set'
    },
    {
      member: 'Coordinates.longitude',
      operator: 'set'
    }
  ]
};


// Query to group companies according to districts - fulfill filters
export var districtsQuery = {
  measures: [
    'Facts.count',
    'Facts.providesService'
  ],
  dimensions: [
    'Location.district'
  ],
  filters: [
    {
      member: 'Location.district',
      operator: 'set'
    }]
};

// Query to group companies according to cities - fulfill filters
export var citiesQuery = {
  measures: [
    'Facts.count',
    'Facts.providesService'
  ],
  dimensions: [
    'Location.district',
    'Location.city'
  ],
  filters: [
    {
      member: 'Location.district',
      operator: 'set'
    },
    {
      member: 'Location.city',
      operator: 'set'
    }]
};

// Query to group companies according to parishes - fulfill filters
export var parishesQuery = {
  measures: [
    'Facts.count',
    'Facts.providesService'
  ],
  dimensions: [
    'Location.district',
    'Location.city',
    'Location.parish',
    'Location.id'
  ],
  filters: [
    {
      member: 'Location.district',
      operator: 'set'
    },
    {
      member: 'Location.city',
      operator: 'set'
    },
    {
      member: 'Location.parish',
      operator: 'set'
    }]
};

// Query to group companies according to districts and activities
var districtsActivityQuery = {
  measures: [
    'Facts.count',
    'Facts.providesService'
  ],
  dimensions: [
    'Location.district',
    'Activity.id',
    'Activity.activity'
  ],
  filters: [
    {
      member: 'Location.district',
      operator: 'set'
    }]
};

// Query to group companies according to cities and activities
var citiesActivityQuery = {
  measures: [
    'Facts.count',
    'Facts.providesService'
  ],
  dimensions: [
    'Location.district',
    'Location.city',
    'Activity.id',
    'Activity.activity'
  ],
  filters: [
    {
      member: 'Location.district',
      operator: 'set'
    },
    {
      member: 'Location.city',
      operator: 'set'
    }]
};

// Query to group companies according to parishes and activities
var parishesActivityQuery = {
  measures: [
    'Facts.count',
    'Facts.providesService'
  ],
  dimensions: [
    'Location.district',
    'Location.city',
    'Location.parish',
    'Location.id',
    'Activity.id',
    'Activity.activity'
  ],
  filters: [
    {
      member: 'Location.district',
      operator: 'set'
    },
    {
      member: 'Location.city',
      operator: 'set'
    },
    {
      member: 'Location.parish',
      operator: 'set'
    }]
};

// Query to group jobs according to its own groups stored at the Bridge table

var jobsQuery = {
  measures: [
    'Facts.count'
  ],
  dimensions: [
    'Bridge.idGroup',
    'Job.description',
    'Job.id'
  ],
  filters: [
    {
      member: 'Job.description',
      operator: 'set'
    }
  ]
};

// Query to display all jobs' groups
var groupsQuery = {
  measures: [
    'Facts.count',
    'Facts.providesService'
  ],
  dimensions: [
    'Bridge.idGroup'
  ],
  filters: [
    {
      member: 'Job.description',
      operator: 'set'
    }
  ]
};

// Query to group companies according to their activities - fulfill filters
export var activityQuery = {
  measures: [
    'Facts.providesService',
    'Facts.count'
  ],
  dimensions: [
    'Activity.id',
    'Activity.activity'
  ],
  filters: [
    {
      member: 'Activity.activity',
      operator: 'set'
    }
  ]
};

// Query to group companies according to their categories - fulfill filters
export var categoryQuery = {
  measures: [
    'Facts.providesService',
    'Facts.count'
  ],
  dimensions: [
    'Activity.category'
  ],
  filters: [
    {
      member: 'Activity.category',
      operator: 'set'
    }
  ]
};

// Query to group companies according to their cae cirs - fulfill filters
export var caecirsQuery = {
  measures: [
    'Facts.providesService',
    'Facts.count'
  ],
  dimensions: [
    'CaeCirs.id',
    'CaeCirs.code',
    'CaeCirs.description'
  ],
  filters: [
    {
      member: 'CaeCirs.description',
      operator: 'set'
    }
  ]
};

// Get relevant aggregated facts
var factsQuery = {
  measures: [
    'Facts.count',
    'Facts.hasAccount',
    'Facts.isRegistered',
    'Facts.isActive',
    'Facts.providesService'
  ]
};

// Query to retrieve companies' contacts
var contactsQuery = {
  measures: [
    'Facts.count'
  ],
  dimensions: [
    'Company.id',
    'Company.name',
    'Contacts.phone',
    'Contacts.fax',
    'Contacts.website',
    'Contacts.email',
    'Contacts.facebook',
    'Company.address'
  ]
};

// Array with the basic queries used to serve the most basic charts included in the website
var basicQueries = [{'queryName': 'factsQuery', 'query': factsQuery},
  {'queryName': 'contactsQuery', 'query': contactsQuery},
  {'queryName': 'jobsQuery', 'query': jobsQuery},
  {'queryName': 'mapQuery', 'query': mapQuery},
  {'queryName': 'caecirsQuery', 'query': caecirsQuery},
  {'queryName': 'activityQuery', 'query': activityQuery},
  {'queryName': 'categoryQuery', 'query': categoryQuery},
  {'queryName': 'groupsQuery', 'query': groupsQuery},
  {'queryName': 'districtQuery', 'query': districtsQuery},
  {'queryName': 'citiesQuery', 'query': citiesQuery},
  {'queryName': 'parishesQuery', 'query': parishesQuery},
  {'queryName': 'districtsActivityQuery', 'query': districtsActivityQuery},
  {'queryName': 'citiesActivityQuery', 'query': citiesActivityQuery},
  {'queryName': 'parishesActivityQuery', 'query': parishesActivityQuery}];

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////// START INDEXEDDB ///////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// Call on indexedDB
if (!window.indexedDB) {
  console.log('This browser doesn\'t support IndexedDB')
} else {
  console.log('This browser supports IndexedDB')
}

// Get version from database with system variables
var version;
var queryDone = false;
var dbVariables = window.indexedDB.open('ioScienceSys', 1);

// structure database
dbVariables.onupgradeneeded = function (event) {
  var database = event.target.result;
  var sysVariables = database.createObjectStore('sysVariables', {keyPath: 'key'});
  sysVariables.createIndex('key', 'key', {unique: true})
};

// load database
dbVariables.onsuccess = function (event) {
  var dbVar = event.target.result;
  loadSysVariables(dbVar);
  var v = getVersionStore(dbVar);
  v.onsuccess = function (event) {
    var result = event.target.result;
    if (result.length === 1) {
      version = result[0].value;
      change(version, dbVar)
    } else {
      version = result[1].value;
      change(version, dbVar)
    }
  }
};

function change (versi) {
  window.version = versi
}

var db = window.indexedDB.open('ioScience', window.version);

// RETRIEVE THE LAST VERSION FROM INDEXEDDB
function getVersionStore (dbVariables) {
  var tx = dbVariables.transaction('sysVariables', 'readwrite');
  var objectStore = tx.objectStore('sysVariables');
  return objectStore.getAll()
}

//
function loadSysVariables (dbVar) {
  var tx = dbVar.transaction('sysVariables', 'readwrite');
  var objectStore = tx.objectStore('sysVariables');
  objectStore.put({key: 'ioScienceFirst', value: 1})
}

// var db = window.indexedDB.open('ioScience', 1)

// BUILD DATABASE
db.onupgradeneeded = function (event) {
  var database = event.target.result;

  // OBJECTSTORES
  var mapQuery = database.createObjectStore('mapQuery', {keyPath: 'key'});
  mapQuery.createIndex('key', 'key', {unique: true});

  var jobsQuery = database.createObjectStore('jobsQuery', {keyPath: 'key'});
  jobsQuery.createIndex('key', 'key', {unique: false});

  var factsQuery = database.createObjectStore('factsQuery', {keyPath: 'key'});
  factsQuery.createIndex('key', 'key', {unique: true});

  var groupsQuery = database.createObjectStore('groupsQuery', {keyPath: 'key'});
  groupsQuery.createIndex('key', 'key', {unique: true});

  var contactsQuery = database.createObjectStore('contactsQuery', {keyPath: 'key'});
  contactsQuery.createIndex('key', 'key', {unique: true});

  var districtsQuery = database.createObjectStore('districtsQuery', {keyPath: 'key'});
  districtsQuery.createIndex('key', 'key', {unique: true});

  var citiesQuery = database.createObjectStore('citiesQuery', {keyPath: 'key'});
  citiesQuery.createIndex('key', 'key', {unique: false});

  var parishesQuery = database.createObjectStore('parishesQuery', {keyPath: 'key'});
  parishesQuery.createIndex('key', 'key', {unique: true});

  var districtsActivityQuery = database.createObjectStore('districtsActivityQuery', {keyPath: 'key'});
  districtsActivityQuery.createIndex('key', 'key', {unique: true});

  var citiesActivityQuery = database.createObjectStore('citiesActivityQuery', {keyPath: 'key'});
  citiesActivityQuery.createIndex('key', 'key', {unique: false});

  var parishesActivityQuery = database.createObjectStore('parishesActivityQuery', {keyPath: 'key'});
  parishesActivityQuery.createIndex('key', 'key', {unique: true});

  var activityQuery = database.createObjectStore('activityQuery', {keyPath: 'key'});
  activityQuery.createIndex('key', 'key', {unique: true});

  var categoryQuery = database.createObjectStore('categoryQuery', {keyPath: 'key'});
  categoryQuery.createIndex('key', 'key', {unique: true});

  var caecirsQuery = database.createObjectStore('caecirsQuery', {keyPath: 'key'});
  caecirsQuery.createIndex('key', 'key', {unique: true});

  var queries = database.createObjectStore('queries', {keyPath: 'key'});
  queries.createIndex('key', 'key', {unique: true})
};

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////// LOAD INDEXEDDB ////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// LOAD DATABASE
db.onsuccess = function (event) {
  var db = event.target.result;
  loadParishesQuery(db);
  loadMapQuery(db);
  loadJobsQuery(db);
  loadFactsQuery(db);
  loadGroupsQuery(db);
  loadContactsQuery(db);
  loadDistrictsQuery(db);
  loadCitiesQuery(db);
  loadActivityQuery(db);
  loadCategoryQuery(db);
  loadCaecirsQuery(db);
  loadDistrictsActivityQuery(db);
  loadCitiesActivityQuery(db);
  loadParishesActivityQuery(db);
  writeQueries(db)
};

//load basic queries data into indexedDB
function writeQueries (db) {
  var tx = db.transaction('queries', 'readwrite');
  var objectStore = tx.objectStore('queries');
  for (var i = 0; i < basicQueries.length; i++) {
    objectStore.put({key: basicQueries[i].queryName, value: basicQueries[i].query})
  }
}

function loadMapQuery (db) {
  readMapQuery(function (data) {
    var tx = db.transaction('mapQuery', 'readwrite');
    var store = tx.objectStore('mapQuery');
    data.forEach(function (x) {
      var valor = x['Company.id'];
      store.put({key: valor, value: x})
    });
    //console.log(data)
    tx.oncomplete = function () {
      // db.close();
    }
  })
}

function readMapQuery (callback) {
  $.get('http://iohub-companies-cubes.herokuapp.com/mapQuery', function (data) {
    callback(data)
  })
}

function loadDistrictsQuery (db) {
  readDistrictsQuery(function (data) {
    var tx = db.transaction('districtsQuery', 'readwrite');
    var store = tx.objectStore('districtsQuery');
    data.forEach(function (x) {
      var valor = x['Location.district'];
      store.put({key: valor, value: x})
    });
    //console.log(data)
    tx.oncomplete = function () {
      // db.close();
    }
  })
}

function readDistrictsQuery (callback) {
  $.get('http://iohub-companies-cubes.herokuapp.com/districtsQuery', function (data) {
    callback(data)
  })
}

function loadCitiesQuery (db) {
  readCitiesQuery(function (data) {
    var tx = db.transaction('citiesQuery', 'readwrite');
    var store = tx.objectStore('citiesQuery');
    data.forEach(function (x) {
      var valor = '' + x['Location.district'] + '' + x['Location.city'];
      store.put({key: valor, value: x})
    });
    //console.log(data)
    tx.oncomplete = function () {
      // db.close();
    }
  })
}

function readCitiesQuery (callback) {
  $.get('http://iohub-companies-cubes.herokuapp.com/citiesQuery', function (data) {
    callback(data)
  })
}

function loadParishesQuery (db) {
  readParishesQuery(function (data) {
    var tx = db.transaction('parishesQuery', 'readwrite');
    var store = tx.objectStore('parishesQuery');
    data.forEach(function (x) {
      var valor = x['Location.id'];
      store.put({key: valor, value: x})
    });
    //console.log(data)
    tx.oncomplete = function () {
      // db.close();
    }
  })
}

function readParishesQuery (callback) {
  $.get('http://iohub-companies-cubes.herokuapp.com/parishesQuery', function (data) {
    callback(data)
  })
}

function loadDistrictsActivityQuery (db) {
  readDistrictsActivityQuery(function (data) {
    var tx = db.transaction('districtsActivityQuery', 'readwrite');
    var store = tx.objectStore('districtsActivityQuery');
    data.forEach(function (x) {
      var valor = '' + x['Location.district'] + '' + x['Activity.id'];
      store.put({key: valor, value: x})
    });
    //console.log(data)
    tx.oncomplete = function () {
      // db.close();
    }
  })
}

function readDistrictsActivityQuery (callback) {
  $.get('http://iohub-companies-cubes.herokuapp.com/districtsActivityQuery', function (data) {
    callback(data)
  })
}

function loadCitiesActivityQuery (db) {
  readCitiesActivityQuery(function (data) {
    var tx = db.transaction('citiesActivityQuery', 'readwrite');
    var store = tx.objectStore('citiesActivityQuery');
    data.forEach(function (x) {
      var valor = '' + x['Location.district'] + '' + x['Location.city'] + '' + x['Activity.id'];
      store.put({key: valor, value: x})
    });
    //console.log(data)
    tx.oncomplete = function () {
      // db.close();
    }
  })
}

function readCitiesActivityQuery (callback) {
  $.get('http://iohub-companies-cubes.herokuapp.com/citiesActivityQuery', function (data) {
    callback(data)
  })
}

function loadParishesActivityQuery (db) {
  readParishesActivityQuery(function (data) {
    var tx = db.transaction('parishesActivityQuery', 'readwrite');
    var store = tx.objectStore('parishesActivityQuery');
    data.forEach(function (x) {
      var valor = '' + x['Location.id'] + '' + x['Activity.id'];
      store.put({key: valor, value: x})
    });
    //console.log(data)
    tx.oncomplete = function () {
      // db.close();
    }
  })
}

function readParishesActivityQuery (callback) {
  $.get('http://iohub-companies-cubes.herokuapp.com/parishesActivityQuery', function (data) {
    callback(data)
  })
}

function loadCaecirsQuery (db) {
  readCaecirsQuery(function (data) {
    var tx = db.transaction('caecirsQuery', 'readwrite');
    var store = tx.objectStore('caecirsQuery');
    data.forEach(function (x) {
      var valor = x['CaeCirs.id'];
      store.put({key: valor, value: x})
    });
    //console.log(data)
    tx.oncomplete = function () {
      // db.close();
    }
  })
}

function readCaecirsQuery (callback) {
  $.get('http://iohub-companies-cubes.herokuapp.com/caecirsQuery', function (data) {
    callback(data)
  })
}

function loadActivityQuery (db) {
  readActivityQuery(function (data) {
    var tx = db.transaction('activityQuery', 'readwrite');
    var store = tx.objectStore('activityQuery');
    data.forEach(function (x) {
      var valor = x['Activity.id'];
      store.put({key: valor, value: x})
    });
    //console.log(data)
    tx.oncomplete = function () {
      // db.close();
    }
  })
}

function readActivityQuery (callback) {
  $.get('http://iohub-companies-cubes.herokuapp.com/activityQuery', function (data) {
    callback(data)
  })
}

function loadCategoryQuery (db) {
  readCategoryQuery(function (data) {
    var tx = db.transaction('categoryQuery', 'readwrite');
    var store = tx.objectStore('categoryQuery');
    data.forEach(function (x) {
      var valor = x['Activity.category'];
      store.put({key: valor, value: x})
    });
    //console.log(data)
    tx.oncomplete = function () {
      // db.close();
    }
  })
}

function readCategoryQuery (callback) {
  $.get('http://iohub-companies-cubes.herokuapp.com/categoryQuery', function (data) {
    callback(data)
  })
}

function loadJobsQuery (db) {
  readJobsQuery(function (data) {
    var tx = db.transaction('jobsQuery', 'readwrite');
    var store = tx.objectStore('jobsQuery');
    data.forEach(function (x) {
      var valor = '' + x['Bridge.idGroup'] + '' + x['Job.id'];
      store.put({key: valor, value: x})
    });
    //console.log(data)
    tx.oncomplete = function () {
      // db.close();
    }
  })
}

function readJobsQuery (callback) {
  $.get('http://iohub-companies-cubes.herokuapp.com/jobsQuery', function (data) {
    callback(data)
  })
}

function loadFactsQuery (db) {
  readFactsQuery(function (data) {
    var tx = db.transaction('factsQuery', 'readwrite');
    var store = tx.objectStore('factsQuery');
    data.forEach(function (x) {
      var valor = x['Facts.count'];
      store.put({key: valor, value: x})
    });
    //console.log(data)
    tx.oncomplete = function () {
      // db.close();
    }
  })
}

function readFactsQuery (callback) {
  $.get('http://iohub-companies-cubes.herokuapp.com/factsQuery', function (data) {
    callback(data)
  })
}

function loadGroupsQuery (db) {
  readGroupsQuery(function (data) {
    var tx = db.transaction('groupsQuery', 'readwrite');
    var store = tx.objectStore('groupsQuery');
    data.forEach(function (x) {
      var valor = x['Bridge.idGroup'];
      store.put({key: valor, value: x})
    });
    //console.log(data)
    tx.oncomplete = function () {
      // db.close();
    }
  })
}

function readGroupsQuery (callback) {
  $.get('http://iohub-companies-cubes.herokuapp.com/groupsQuery', function (data) {
    callback(data)
  })
}

function loadContactsQuery (db) {
  readContactsQuery(function (data) {
    var tx = db.transaction('contactsQuery', 'readwrite');
    var store = tx.objectStore('contactsQuery');
    data.forEach(function (x) {
      var valor = x['Company.id'];
      store.put({key: valor, value: x})
    });
    //console.log(data)
    tx.oncomplete = function () {
      // db.close();
    }
  })
}

function readContactsQuery (callback) {
  $.get('http://iohub-companies-cubes.herokuapp.com/contactsQuery', function (data) {
    callback(data)
  })
}

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////// UPDATE INDEXEDDB //////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

// Function to verify if a given query is already represented in an objectStore in the database
export function verifyQuery (queryName, queryAsked, indexer) {
  console.log(window.version)
  var db = window.indexedDB.open('ioScience', window.version);
  var exist = false;
  db.onsuccess = function (event) {
    console.log('query name created');
    var db = event.target.result;
    var tx = db.transaction('queries', 'readwrite');
    var store = tx.objectStore('queries');
    var queriesStored = store.getAll();

    queriesStored.onsuccess = function (evt) {
      console.log('checking if query exist');
      var queries = evt.target.result;
      var exist = false;
      for (var i = 0; i < queries.length; i++) {
        if (queries[i].key === queryName) {
          exist = true;
          eventBus.$emit('selectedCompany', queryDone);
          // callExistentQuery(queryName, queryAsked)
          break
        }
      }
      if (exist === false) {
        // Request of a new query and storage of its data
        if (navigator.onLine) {

          //Update Version
          window.version = window.version + 1;

          loadFilterQuery(db, queryName, queryAsked, indexer);
          saveNewQuery(db, queryName, queryAsked);

          // Actualize version in system variables database
          var dbVariables = window.indexedDB.open('ioScienceSys', 1);
          dbVariables.onsuccess = function (event) {
            dbVariables = event.target.result;
            var tx = dbVariables.transaction('sysVariables', 'readwrite');
            var objectStore = tx.objectStore('sysVariables');
            objectStore.put({key: 'ioScienceLast', value: window.version})
          }
        } else {
          alert('Your request demands internet connection, please try connect yourself to a network and try again!')
        }
      }
    }
  }
}

// Function to store data from a new query in indexedDB
function saveNewQuery (db, queryName, queryAsked) {
  var tx = db.transaction('queries', 'readwrite');
  var objectStore = tx.objectStore('queries');
  objectStore.put({key: queryName, value: JSON.parse(queryAsked)})
}

// Load data from the new query to indexedDB
function loadFilterQuery (db, queryName, queryAsked, indexer) {

  // Create a new objectStore inside ioScience database to store the new query data
  db = window.indexedDB.open('ioScience', window.version);
  db.onupgradeneeded = function (event) {
    console.log('query table crated');
    var database = event.target.result;
    var newQuery = database.createObjectStore(queryName, {keyPath: 'key'});
    newQuery.createIndex('key', 'key', {unique: true})
  };

  readFilterQuery(function (data) {
    db.onsuccess = function (event) {
      console.log('query table fulfilled')
      db = event.target.result;
      var tx = db.transaction(queryName, 'readwrite');
      var store = tx.objectStore(queryName);
      console.log(store)
      data.forEach(function (x) {
        console.log(x[indexer])
        var valor = x[indexer];
        store.put({key: valor, value: x})
      });
      //console.log(data)
      tx.oncomplete = function () {
        db.close();
      }
    }
  }, queryAsked);

  window.queryDone = true;
  eventBus.$emit('selectedCompany', queryDone)
}

// Request to Cubejs of a new query based in a filter - NOT WORKING
function readFilterQuery (callback, queryAsked) {
  queryAsked = queryAsked.replace(/'/g, '"');
  $.get('http://iohub-companies-cubes.herokuapp.com/filtersQuery/?filter=' + queryAsked, function (data) {
    callback(data)
  })
}

// QUERIES => INDEXEDDB
// ======EXAMPLE====== Called in index.html line 22
function getIndexedDBDimActivity (callback) {
  var result = [];
  var db = window.indexedDB.open('ioScience', window.version);

  db.onsuccess = function (event) {
    var db = event.target.result;
    var tx = db.transaction('contactsQuery', 'readwrite');
    var store = tx.objectStore('contactsQuery');
    var getAllItemsFromDatabase = store.getAll();
    getAllItemsFromDatabase.onsuccess = function () {
      result = getAllItemsFromDatabase.result;
      callback(result)
    };
    tx.oncomplete = function () {
      db.close()
    }
  }
}
